import { CLIENTS } from './clients';

// The table of contents. Order here is the nav order and the prev/next order.
//
// Every id except START is a URL segment and must match
// Web::DevelopersController::TOPICS — the server owns the whitelist (unknown
// paths are a 404), this file owns titles and grouping.
export type TopicItem = { id: string; label: string; sub?: string };
export type TopicGroup = { label: string; items: TopicItem[] };

export const START = 'start';

export const TOPIC_GROUPS: TopicGroup[] = [
  { label: '开始', items: [{ id: START, label: '怎么接' }] },
  { label: '客户端MCP', items: CLIENTS.map((c) => ({ id: c.slug, label: c.label, sub: c.how })) },
  { label: 'Skills', items: [{ id: 'worklog-hook', label: 'Worklog skills' }] },
  {
    label: '接上之后',
    items: [
      { id: 'tools', label: '能做什么' },
      { id: 'rules', label: '它会守的规则' },
    ],
  },
];

export const TOPICS: TopicItem[] = TOPIC_GROUPS.flatMap((g) => g.items);

export const topicPath = (id: string): string => (id === START ? '/developers' : `/developers/${id}`);

export const findTopic = (id: string): TopicItem => TOPICS.find((t) => t.id === id) ?? TOPICS[0];
